import * as React from 'react';

import { SuggestionsResponsePayload } from 'api/api';

import googleLogo from '~src/icons/google-logo.png';
import { MapboxLogo } from '~src/icons/mapbox-logo';

interface PoweredByFooterProps {
  provider?: SuggestionsResponsePayload['provider'];
}

// TODO: introduce logos for geposit and loqate
const TEMP_PROVIDERS_WITHOUT_LOGOS = ['geposit', 'loqate', 'no_provider'];

export const PoweredByFooter: React.FC<PoweredByFooterProps> = ({ provider }) => {
  if (!provider || TEMP_PROVIDERS_WITHOUT_LOGOS.includes(provider)) {
    return null;
  }
  // TODO: sizes of the logos are temporary, we're waiting for them on ui mockups
  return (
    <div css={styles.wrapper(provider)}>
      {provider === 'google' ? (
        <img css={styles.imageLogo} src={googleLogo} alt="powered by google" />
      ) : (
        <MapboxLogo ariaName="Mapbox logo" height={30 / window.devicePixelRatio} />
      )}
    </div>
  );
};

const styles = {
  wrapper: (provider: string) => ({
    justifyContent: 'flex-end',
    display: 'flex',
    padding: provider === 'google' ? 5 : 30 / window.devicePixelRatio,
  }),
  imageLogo: {
    height: 18 / window.devicePixelRatio,
  },
};
